import {
  Box, Button, Modal, Stack,
} from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import {
  useEffect, useMemo, useState,
} from 'react';
import { v4 as uuid } from 'uuid';
import BlockData from '../../../../models/BlockData';
import LinkComponent from '../../../Link/LinkComponent';
import { URLOpenType } from '../../../../models/URLOpenType';
import { URLTargetType } from '../../../../models/URLTargetType';
import LinkData from '../../../../models/LinkData';
import ErrorText from '../../../ErrorText';

const style = {
  position: 'absolute',
  overflow: 'auto',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  maxWidth: '80%',
  maxHeight: '80%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

export type HeaderMenuSettingsModalCloseHandler = (newItems?: LinkData[]) => void;

function HeaderMenuSettingsModal({
  menuItems, open, closeHandler, blockData,
}: { menuItems: LinkData[], open: boolean, closeHandler: HeaderMenuSettingsModalCloseHandler, blockData: BlockData[] }) {
  const [managedItems, setManagedItems] = useState<LinkData[]>(JSON.parse(JSON.stringify(menuItems)));
  const [error, setError] = useState('');

  const handleClose = () => {
    setError('');
    closeHandler(null);
  };

  const handleSave = () => {
    if (!managedItems.find((item) => item.title === '')) {
      setError('');
      closeHandler(managedItems);
    } else {
      setError('タイトルを入力してください');
    }
  };

  const handleAdd = () => {
    setManagedItems([...managedItems, LinkData.getDefault('新規')]);
  };

  const items = useMemo(() => {
    if (managedItems.length > 0) {
      return managedItems.map((link, index) => (
        <LinkComponent
          key={uuid()}
          link={link}
          blockData={blockData}
          onRemoveBlock={() => setManagedItems(managedItems.filter((item) => item !== link))}
          onChangeURLTitle={(newTitle) => { managedItems[index].title = newTitle; }}
          onChangeTargetType={(newTargetType) => {
            if (newTargetType === URLTargetType.INTERNAL) {
              managedItems[index].linkData.targetType = newTargetType;
              managedItems[index].linkData.openType = URLOpenType.SAME_PAGE;
            } else {
              managedItems[index].linkData.targetType = newTargetType;
            }
            setManagedItems([...managedItems]);
          }}
          onSelectBlock={(selected) => {
            managedItems[index].linkData.url = selected;
            setManagedItems([...managedItems]);
          }}
          onChangeLink={(newLink) => { managedItems[index].linkData.url = newLink; }}
          onChangeOpenType={(checked) => {
            managedItems[index].linkData.openType = checked ? URLOpenType.NEW_TAB : URLOpenType.SAME_PAGE;
            setManagedItems([...managedItems]);
          }}
        />
      ));
    }

    return [];
  }, [blockData, managedItems]);

  useEffect(() => {
    if (!open) {
      setManagedItems(JSON.parse(JSON.stringify(menuItems)));
    }
  }, [menuItems, open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box sx={style}>
        <Stack spacing={4}>
          {items}

          <Stack key="add" spacing={0} sx={{ border: '1px dashed lightGray', p: 0 }}>
            <Button color="primary" onClick={handleAdd}>
              <AddCircleRoundedIcon />
            </Button>
          </Stack>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Button variant="outlined" color="primary" onClick={() => { handleClose(); }}>
              キャンセル
            </Button>

            {error ? <ErrorText text={error} /> : null}

            <Button variant="contained" color="primary" onClick={() => { handleSave(); }}>
              適用
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default HeaderMenuSettingsModal;
